import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import methods from "../../services/utility";
import apiMethod from "../../services/api-service";

import send from "../../assets/images/icons/send.svg";
import home from "../../assets/images/icons/home-hashtag.svg";

const RestaurantAccountingSidebar = () => {
  const { restaurantId } = useParams();
  const [logo, setLogo] = useState("");

  const branchInfo = async () => {
    const resp = await apiMethod.getRestaurantInfo(restaurantId);
    if (!methods.showApiErrors(resp)) return false;
    setLogo(resp.data.logo);
  };

  useEffect(() => {
    branchInfo();
  }, []);

  const renderSidebar = () => {
    return (
      <>
        <>
          <div
            className="offcanvas-lg offcanvas-start"
            tabIndex="-1"
            id="sidebarMenu"
            aria-labelledby="sidebarMenuLabel"
          >
            <div className="offcanvas-header">
              <p className="offcanvas-title" id="sidebarMenuLabel"></p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                data-bs-target="#sidebarMenu"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body d-lg-flex flex-column overflow-y-auto">
              <div className="text-center border-bottom">
                <img
                  src={
                    logo
                      ? process.env.REACT_APP_ADMIN_PANEL_API + "/" + logo
                      : methods.normalImage("", "logo")
                  }
                  className="img-fluid rounded-circle my-1"
                  style={{ height: "100px" }}
                />
              </div>
              <Link to={`/warehouse/${restaurantId}`} className="link">
                <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                  <div>
                    <img src={home} alt="home" />
                    <span className="pe-1">انبار</span>
                  </div>
                  <div>
                    <span className="badge sidebar-badge rounded-pill"></span>
                    <span className="">
                      <img src={send} alt="arrowLeft" />
                    </span>
                  </div>
                </li>
              </Link>
              <Link
                to={`/baseinfo/restaurant/${restaurantId}`}
                className="link"
              >
                <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                  <div>
                    <i className="bi bi-info-circle fs-5"></i>
                    <span className="pe-1">اطلاعات عمومی</span>
                  </div>
                  <div>
                    <span className="badge sidebar-badge rounded-pill"></span>
                    <span className="">
                      <img src={send} alt="arrowLeft" />
                    </span>
                  </div>
                </li>
              </Link>
            </div>
          </div>
        </>
      </>
    );
  };

  return <>{renderSidebar()}</>;
};

export default RestaurantAccountingSidebar;
